import { Injectable, inject } from '@angular/core';

import { I18NEXT_SERVICE } from 'angular-i18next';

import { BreadcrumbItem } from '@hdms/shared/common-types';
import { ROUTER_BREADCRUMB_TRANSLATE, RouterBreadcrumbTranslate } from '@hdms/shared/util-core';

@Injectable()
class RouterBreadcrumbTranslationService implements RouterBreadcrumbTranslate {
  readonly i18nNamespaceProp = 'i18nextNamespaces';
  readonly rootBreadCrumbItem: BreadcrumbItem = {
    title: 'home',
    href: '/'
  };

  private readonly i18NextService = inject(I18NEXT_SERVICE);

  public translate(breadcrumbItems: BreadcrumbItem[], namespaces: string[]): BreadcrumbItem[] {
    return breadcrumbItems.map(bc => {
      const keyPrefix = bc.title.includes('.') ? '' : 'breadcrumb.';
      const key = `${keyPrefix}${bc.title}`;
      const ns = namespaces.find(n => this.i18NextService.exists(key, { ns: n }));
      return {
        ...bc,
        title: this.i18NextService.t(key, { ...bc.routeParams, ns })
      };
    });
  }
}

export const ROUTER_BREADCRUMB_TRANSLATION_PROVIDER = {
  provide: ROUTER_BREADCRUMB_TRANSLATE,
  useClass: RouterBreadcrumbTranslationService
};
